import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { Section } from './types';
import { DashBoardCard } from './DashBoardCard';
import { AdminHeaderCompanyLogo } from 'components/pages/BrandPortal/Users/AdminPagesHeader';
import { useBrandPortalEventKey } from 'hooks/useBrandPortalEventKey';
import { useNavigate } from 'react-router-dom';

export const AdminDashboard: React.FC<{
  sections: Section[];
  description?: string;
  withLogo?: boolean;
  showPortalSearchButton?: boolean;
}> = ({ sections, description, withLogo, showPortalSearchButton }) => {
  const navigate = useNavigate();
  const event = useBrandPortalEventKey();
  return (
    <>
      <Helmet>
        <title>Admin dashboard</title>
      </Helmet>
      <Box>
        <Card
          sx={{
            width: '100%',
            my: 3,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            p: 3
          }}
        >
          <Stack spacing={2}>
            <Typography variant="h3">Admin</Typography>

            {description && <Typography>{description}</Typography>}
            {showPortalSearchButton && (
              <Button
                sx={{ width: 200 }}
                onClick={() => navigate(`/search/ingredients/${event}`)}
                variant="contained"
              >
                Go to portal search page
              </Button>
            )}
          </Stack>
          {withLogo && <AdminHeaderCompanyLogo event={event} />}
        </Card>

        <Stack
          sx={{
            display: 'grid',
            gridTemplateColumns: { sm: '1fr', lg: '1fr 1fr' },
            gap: 3,
            alignItems: 'stretch',
            gridAutoRows: '1fr'
          }}
        >
          {sections
            .filter((s: Section) => s.hasAccess)
            .map(sec => (
              <DashBoardCard {...sec} key={sec.title} />
            ))}
        </Stack>
      </Box>
    </>
  );
};
